export default class MediaIframe {
  constructor() {
    let MediaIframe = this;

    document.body.onclick = function (element) {
      if (MediaIframe.canShow()) {
        let id = MediaIframe.findId(element.target);

        if (id) {
          MediaIframe.show(id);
        }
      }
    };

    if (location.href.includes("hideSidebar")) {
      window.onload = function () {
        document.getElementById("application").insertAdjacentHTML(
          "beforeend",
          `
                    <style>
                        .navigation--1BnwPeruqX 
                        {
                            display: none;
                        }
                        
                        .content--2ItRbsX0DB.with-pinned-navigation--TApMaXD6O2
                        {
                            width: 100vw;
                        }
                        .root--D3obmV_09j{
                            left:0;
                        }
                    </style>
                `
        );
      };
    }
  }

  findId(element) {
    try {
      return this.getParent(
        element,
        "cell--2xIOdlYl17"
      ).nextSibling.querySelectorAll("input")[0].value;
    } catch (error) {
      return null;
    }
  }

  canShow() {
    let element = document.getElementsByClassName("header--fq2VFJLyx5");

    if (!element.length) {
      return false;
    }

    if (element[0].firstChild.textContent === "Select media") {
      return true;
    }

    if (element[0].firstChild.textContent === "Medien auswählen") {
      return true;
    }
  }

  show(id) {
    document.getElementById("application").insertAdjacentHTML(
      "beforeend",
      `
            <div id="MediaIframe" onclick="this.remove()">
                <style>
                    #MediaIframe
                    {
                      z-index: 10000000; position: absolute; width: 100vw; height: 100vh; padding: 100px; background: #0000008f; top: 0; bottom: 0; left: 0; right: 0;
                    }
                    
                    #MediaIframe iframe
                    {
                      background#fff; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; width: calc(100% - 100px); height: calc(100% - 100px); border: 5px solid #fff;
                    }
                </style>
                <iframe src="/admin/#/media/de/${id}/details?hideSidebar"></iframe>
            </div>
        `
    );
  }

  getParent(element, classes) {
    if (element.classList.contains(classes)) {
      return el;
    }

    while (
      (element = element.parentElement) &&
      !element.classList.contains(classes)
    );
    return element;
  }
}
